import { render, staticRenderFns } from "./BankAccountFormStep.vue?vue&type=template&id=f8278c50&"
import script from "./BankAccountFormStep.vue?vue&type=script&lang=js&"
export * from "./BankAccountFormStep.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountFormStep.vue?vue&type=style&index=0&id=f8278c50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports